<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-09-10 09:18:20
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-09-13 09:02:13
 * @FilePath: \vue-privilege-routing\src\pages\business\shop-mall\goods-manage\index.vue
-->
<template>
  <div class="app-container">
    <el-row>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="名称">
          <el-input v-model="page.param.title" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item label="类别">
          <el-select
            v-model="page.param.categoryId"
            filterable
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in categoryIdOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门店">
          <el-select
            v-model="page.param.storeId"
            filterable
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in storeIdOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            v-model="page.param.goodsState"
            filterable
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search" class="el-icon-search">
            查询</el-button
          >
        </el-form-item>
      </el-form>
    </el-row>

    <el-row>
      <el-col style="text-align: left;margin-bottom: 5px;">
        <el-button @click="add()" type="primary" class="el-icon-edit-outline">
          添加</el-button
        >
      </el-col>
    </el-row>

    <el-table
      v-loading="page.loading"
      :data="page.data"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      @sort-change="sortChange"
    >
      <el-table-column label="名称" prop="title" sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.goodsName }}
        </template>
      </el-table-column>
      <el-table-column label="类别" prop="categoryId" sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.catesId }}
        </template>
      </el-table-column>
      <el-table-column label="门店" prop="storeId" sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.storeTitle }}
        </template>
      </el-table-column>
      <el-table-column label="封面" prop="coverImg" sortable="custom">
        <template slot-scope="scope">
          <img
            :src="scope.row.coverImg"
            v-if="'' != scope.row.coverImg"
            width="auto"
            height="30px"
          />
        </template>
      </el-table-column>
      <el-table-column label="销量" prop="sales" sortable="custom" width="80px">
        <template slot-scope="scope">
          {{ scope.row.sales }}
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        prop="status"
        sortable="custom"
        width="80px"
      >
        <template slot-scope="scope">
          {{ scope.row.statusTitle }}
        </template>
      </el-table-column>
      <el-table-column label="更新时间" prop="updateTime" sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.updateTime }}
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="80">
        <template slot-scope="scope">
          <el-button size="mini" @click="edit(scope.row.id)">编辑</el-button>
          <!--          <el-button size="mini" type="danger" @click="del(scope.row.id)"><i class="icon-delete"></i>删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="page.total > 0"
      class="goods-pagination"
      :total="page.total"
      :page.sync="page.param.index"
      :limit.sync="page.param.length"
      @pagination="fetchData"
    />
    <!-- Form -->
    <!-- <el-dialog
      :visible.sync="visible"
      title="添加"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="app-container">
        <el-form
          :model="Form"
          status-icon
          ref="ruleForm"
          label-position="right"
          size="small"
          label-width="150px"
          slot="dialog"
          :rules="rules"
        >
          <el-form-item prop="title" label="名称：">
            <el-input
              v-model="Form.title"
              style="width:400px"
              placeholder="名称"
            ></el-input>
          </el-form-item>
          <el-form-item prop="categoryId" label="类别：">
            <el-select
              v-model="Form.categoryId"
              filterable
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in categoryIdOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="coverImg" label="封面：">
            <el-upload
              class="avatar-uploader"
              :action="uploadUrl"
              :show-file-list="false"
              :on-success="coverImgAfterUpload"
            >
              <img v-if="Form.coverImg" :src="Form.coverImg" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item prop="images" label="图片：">
            <el-upload
              :action="uploadUrl"
              list-type="picture-card"
              :file-list="showImageList"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-success="imageAfterUpload"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item prop="detail" label="详细：">
            <el-upload
              class="avatar-uploader"
              :action="uploadUrl"
              :show-file-list="false"
              :on-success="detailAfterUpload"
            >
              <img v-if="Form.detail" :src="Form.detail" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item prop="postage" label="邮费：">
            <el-input
              v-model="Form.postage"
              style="width:400px"
              placeholder="邮费"
            ></el-input>
          </el-form-item>
          <el-form-item prop="sales" label="销量：">
            <el-input
              v-model="Form.sales"
              style="width:400px"
              placeholder="销量"
            ></el-input>
          </el-form-item>
          <el-form-item prop="status" label="状态：">
            <el-select
              v-model="Form.status"
              filterable
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="processLog" label="流程日志：">
            <el-input
              type="textarea"
              v-model="Form.processLog"
              style="width:400px"
              placeholder="流程日志"
            ></el-input>
          </el-form-item>

          <el-button @click="submit()">提交</el-button>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog> -->
  </div>
</template>

<script>
import { selectGoodsList } from '../../../../api'
import Pagination from '@/components/Pagination'

export default {
  components: { Pagination },
  data() {
    this.rules = {
      // groupName: { type: 'string', required: true, trigger: 'blur', message: '分组必填!' },
      // name: { type: 'string', required: true, trigger: 'blur', message: '编码必填!' },
      // value: { type: 'string', required: true, trigger: 'blur', message: '值必填!' }
    }
    return {
      page: {
        loading: true,
        data: null,
        total: 0,
        param: {
          index: 1,
          length: 10,
          sort: 'id desc'
        }
      },
      uploadUrl: process.env.VUE_APP_BASE_API + '/file/upload',
      visible: false,
      Form: {},

      categoryIdOptions: [],
      storeIdOptions: [],

      statusOptions: [],
      imageList: [],
      showImageList: [],
      dialogImageUrl: ''
    }
  },
  created() {
    // if (this.$route.query.pageIndex !== undefined) {
    //   this.page.param.index = this.$route.query.pageIndex
    // }
    // if (this.$route.query.word !== undefined) {
    //   this.page.param.title = this.$route.query.word
    // }
    this.fetchData()
    // this.categoryIdQuery()
    // this.storeIdQuery()
    // this.statusQuery()
  },
  methods: {
    search() {
      this.page.param.index = 1
      this.fetchData()
    },
    async fetchData() {
      this.page.loading = true

      const formData = new FormData();
      formData.append('pageNumber','1')

      
      // 网络请求
      let result = await selectGoodsList(formData)
      console.log("这是返回的result",result)

      this.page.data = result.datas
      this.page.total = result.totalitems
      this.page.loading = false



      
    },
    sortChange(data) {
      this.page.param.index = 1
      // this.page.param.sort = getSort(data)
      this.fetchData()
    },
//     add() {
//       this.Form = {}
//       this.visible = true
//     },
//     del(val) {
//       let that = this
//       this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
//         confirmButtonText: '确定',
//         cancelButtonText: '取消',
//         type: 'warning',
//         center: true
//       }).then(() => {
//         postForm('/api/v1/app_store_product/delete', { id: val }).then(res => {
//           if (res.code == 200) {
//             that.fetchData()
//           }
//         })
//       })
//     },
//     edit(id) {
//       const that = this
//       that.showImageList = []
//       that.imageList = []
//       postJson('/api/v1/app_store_product/get', { id: id }).then(res => {
//         if (res.code === 200) {
//           that.Form = res.data
//           if (undefined != that.Form.images) {
//             let iList = that.Form.images.split(';')
//             for (let i = 0; i < iList.length; i++) {
//               if (null != iList[i] && '' != iList[i]) {
//                 that.showImageList.push({
//                   name: i,
//                   url: process.env.VUE_APP_BASE_API + iList[i]
//                 })
//                 that.imageList.push(iList[i])
//               }
//             }
//           }
//           that.visible = true
//         }
//       })
//     },
//     submit() {
//       let that = this
//       this.$refs.ruleForm.validate(valid => {
//         if (valid) {
//           that.Form.images = ''
//           that.imageList.forEach(function(x) {
//             that.Form.images = that.Form.images + x + ';'
//           })
//           postJson('/api/v1/app_store_product/save', this.Form).then(
//             response => {
//               if (response.code === 200) {
//                 that.fetchData()
//                 that.visible = false
//               }
//             }
//           )
//         }
//       })
//     },
//     categoryIdQuery() {
//       postJson('/api/v1/app_store_category/select').then(response => {
//         if (response.code === 200) {
//           this.categoryIdOptions = response.data
//         }
//       })
//     },
//     storeIdQuery() {
//       postJson('/api/v1/app_store/select').then(response => {
//         if (response.code === 200) {
//           this.storeIdOptions = response.data
//         }
//       })
//     },
//     coverImgAfterUpload(res, file) {
//       if (res.code == 200) {
//         this.Form.coverImg = process.env.VUE_APP_BASE_API + '/file/' + res.data
//       } else {
//         this.$message.error('文件上传失败!')
//       }
//     },
//     detailAfterUpload(res, file) {
//       if (res.code == 200) {
//         this.Form.detail = process.env.VUE_APP_BASE_API + '/file/' + res.data
//       } else {
//         this.$message.error('文件上传失败!')
//       }
//     },
//     statusQuery() {
//       postJson('/api/adm/sys/dict/select', {
//         groupName: 'app_store_product_status'
//       }).then(response => {
//         if (response.code === 200) {
//           this.statusOptions = response.data
//         }
//       })
//     },
//     handleRemove(file, fileList) {
//       for (let i = 0; i < this.imageList.length; i++) {
//         if (
//           undefined != file.response &&
//           '/file/' + file.response.data == this.imageList[i]
//         ) {
//           this.imageList.splice(i, 1)
//         } else if (
//           file.url ==
//           process.env.VUE_APP_BASE_API + this.imageList[i]
//         ) {
//           this.imageList.splice(i, 1)
//         }
//       }
//     },
//     handlePictureCardPreview(file) {
//       this.dialogImageUrl = file.url
//       this.dialogVisible = true
//     },
//     imageAfterUpload(res, file) {
//       if (res.code == 200) {
//         this.imageList.push('/file/' + res.data)
//       } else {
//         this.$message.error('文件上传失败!')
//       }
//     }
  }
}
</script>
<style lang="scss" scoped>

.app-container {
  padding: 20px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.goods-pagination {
  text-align: right;
}

::v-deep .el-upload--picture-card {
  width: 150px;
  height: 75px;
  line-height: 75px;
}
::v-deep .el-upload-list--picture-card {
  .el-upload-list__item {
    width: 150px;
    height: 75px;
  }
}
</style>
